import compose from "recompose/compose"
import withProps from "recompose/withProps"
import { withNamespaces } from "react-i18next"

const translate = ({ copies, t }) => {
  const translations = {}
  const resolvedCopies = copies || {}

  Object.keys(resolvedCopies).forEach((key) => {
    const value = resolvedCopies[key]
    translations[key] =
      typeof value === "function" ? (params) => t(value(), params) : t(value)
  })

  return translations
}

const withi18n = (input = {}) =>
  compose(
    withNamespaces(),
    withProps((props) =>
      translate({
        copies: typeof input === "function" ? input(props) : input,
        t: props.t,
      }),
    ),
  )

export default withi18n
